import React from "react";
import "./Hero.css";

function Hero() {
	return (
		<div className="hero">
			<h1>Word Finder</h1>
			<p className="lead">
				Having problems finding words given a set of letters? WordFinder
				helps you find those last few problem words.
			</p>
		</div>
	);
}

export default React.memo(Hero);
